<div class="CadastroLayout">
  <main class="CadastroContainer">
    <router-outlet></router-outlet>
  </main>
</div>

<app-ligthboxes-default id="custom-message" class="hidden"></app-ligthboxes-default>
